import React from "react";
import { motion } from "framer-motion";

import logoImg from "../assets/images/mszweb-logo1.png";
import "../assets/fonts/fonts.css";

const NavbarFixed = ({ visible }) => {
  return (
    <div className="relative">
      {/* Navbar */}
      <motion.nav
        initial={{ y: -100, opacity: 0 }} // Initially hidden and above the viewport
        animate={visible ? { y: 0, opacity: 1 } : { y: -100, opacity: 0 }} // Slide down/up based on the boolean
        transition={{ type: "spring", stiffness: 50, damping: 15, delay: 0.15 }}
        className="bg-black bg-opacity-40 fixed w-full top-0 z-10"
      >
        <div className="container mx-auto flex justify-between items-center py-5 px-4 md:px-8">
          {/* Left Navigation */}
          <motion.ul
            key="leftNav"
            initial={{ opacity: 0 }} // Initially hidden and above the viewport
            animate={visible ? { opacity: 1 } : { opacity: 0 }} // Slide down/up based on the boolean
            transition={{ type: "spring", stiffness: 15 }}
            className="flex space-x-3 text-sm pl-2 md:text-xl md:space-x-16" // Smaller text and spacing on mobile, larger on desktop
          >
            {["Home", "Projects"].map((item, index) => (
              <motion.li
                className="px-1 md:px-2"
                key={index}
                whileHover={{ scale: 1.1, color: "#D1D5DB" }}
                transition={{ type: "spring", stiffness: 50, mass: 0.5 }}
              >
                <a
                  href={`${item.toLowerCase()}`}
                  className="text-white hover:text-gray-300 nsans-10-eli"
                >
                  {item}
                </a>
              </motion.li>
            ))}
          </motion.ul>

          {/* Right Navigation */}
          <motion.ul
            key="rightNav"
            initial={{ opacity: 0 }} // Initially hidden and above the viewport
            animate={visible ? { opacity: 1 } : { opacity: 0 }} // Slide down/up based on the boolean
            transition={{ type: "spring", stiffness: 15 }}
            className="flex space-x-3 text-sm pr-2 md:text-xl md:space-x-16" // Smaller text and spacing on mobile, larger on desktop
          >
            {["Extras", "Contact"].map((item, index) => (
              <motion.li
                className="px-1 md:px-2"
                key={index}
                whileHover={{ scale: 1.1, color: "#D1D5DB" }}
                transition={{ type: "spring", stiffness: 50, mass: 0.5 }}
              >
                <a
                  href={`${item.toLowerCase()}`}
                  className="text-white hover:text-gray-300 nsans-10-eli"
                >
                  {item}
                </a>
              </motion.li>
            ))}
          </motion.ul>
        </div>
      </motion.nav>

      {/* Logo overlapping the navbar */}
      <div className="fixed top-5 left-1/2 transform -translate-x-1/2 translate-y-[-30%] z-20">
        <motion.div
          initial={{ y: -20, opacity: 0 }} // Initially hidden and above the viewport
          animate={visible ? { y: 0, opacity: 1 } : { y: -100, opacity: 0 }} // Slide down/up based on the boolean
          transition={{ type: "spring", stiffness: 50 }}
        >
          <a href="/">
            <motion.img
              key="logo"
              transition={{ type: "spring", stiffness: 60 }}
              whileHover={{ scale: 1.1 }}
              src={logoImg}
              alt="Logo"
              className="h-16 w-16 md:h-32 md:w-32 object-contain" // Smaller logo on mobile
            />
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default NavbarFixed;
